import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import { useApplicationVisibilityState } from "@Client/@Composables/application-standalone/machine/useApplicationVisibilityState";
import { additionalIncomesValidator } from "@Client/@Composables/application-standalone/validations/additionalIncomeValidator";
import { applicantsValidator } from "@Client/@Composables/application-standalone/validations/applicantValidator";
import { assetsValidator } from "@Client/@Composables/application-standalone/validations/assetValidator";
import { goalsPageValidator } from "@Client/@Composables/application-standalone/validations/goalsPageValidator";
import { identificationsValidator } from "@Client/@Composables/application-standalone/validations/identificationValidator";
import { incomeHistoriesValidator } from "@Client/@Composables/application-standalone/validations/incomeHistoryValidator";
import { liabilitiesValidator } from "@Client/@Composables/application-standalone/validations/liabilityValidator";
import { otherPropertiesExistingMortgageValidator } from "@Client/@Composables/application-standalone/validations/otherPropertyExistingMortgageValidator";
import { otherPropertiesValidator } from "@Client/@Composables/application-standalone/validations/otherPropertyValidator";
import { subjectPropertyValidator } from "@Client/@Composables/application-standalone/validations/subjectPropertyPageValidator";
import { computed } from "@vue/composition-api";
import { APPLICATION_STEPS } from "@Client/@Utils/enums";
import { useApplicantHelpers } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantHelpers";
import { subjectPropertyExistingMortgagesValidator } from "@Client/@Composables/application-standalone/validations/subjectPropertyExistingMortgageValidator";
export const useValidatorsHelper = () => {
  const {
    visibilityState
  } = useApplicationVisibilityState();
  const visiblePages = computed(() => {
    var _context;
    return _mapInstanceProperty(_context = visibilityState.value).call(_context, ({
      name
    }) => name);
  });
  const isPageVisible = page => {
    var _context2;
    return _includesInstanceProperty(_context2 = visiblePages.value).call(_context2, page);
  };
  const {
    allApplicants,
    allEmployments,
    allAdditionalIncomes,
    allAssets,
    allOtherProperties,
    allOtherPropertiesExistingMortgage,
    allIdentifications,
    allLiabilities,
    isApplicantVisibleFromFillOut
  } = useApplicantHelpers();
  const {
    v$: goalsValidator$
  } = goalsPageValidator({
    lazy: true,
    scope: false
  });
  const {
    v$: subjectPropertyValidator$
  } = subjectPropertyValidator({
    lazy: true,
    scope: false
  });
  const {
    v$: subjectPropertyExistingMortgageValidator$
  } = subjectPropertyExistingMortgagesValidator({
    lazy: true
  });
  const areRulesVisibleFromFillOut = ({
    id,
    applicantId
  }) => isApplicantVisibleFromFillOut(id || applicantId);
  const {
    v$: applicantsValidator$
  } = applicantsValidator({
    lazy: true
  });
  const {
    v$: identificationValidator$
  } = identificationsValidator({
    lazy: true
  });
  const {
    v$: incomeHistoryValidator$
  } = incomeHistoriesValidator({
    lazy: true
  });
  const {
    v$: additionalIncomeValidator$
  } = additionalIncomesValidator({
    lazy: true
  });
  const {
    v$: assetValidator$
  } = assetsValidator({
    lazy: true
  });
  const {
    v$: liabilityValidator$
  } = liabilitiesValidator({
    lazy: true
  });
  const {
    v$: otherPropertyValidator$
  } = otherPropertiesValidator({
    lazy: true
  });
  const {
    v$: otherPropertyExistingMortgageValidator$
  } = otherPropertiesExistingMortgageValidator({
    lazy: true
  });
  const isGoalsPageValid = async () => {
    await goalsValidator$.value.$validate();
    return !goalsValidator$.value.$invalid;
  };
  const isSubjectPropertyValid = async () => {
    if (!isPageVisible(APPLICATION_STEPS.SUBJECT_PROPERTY)) return true;
    await subjectPropertyValidator$.value.$validate();
    return !subjectPropertyValidator$.value.$invalid;
  };
  const areSubjectPropertyExistingMortgagesValid = async () => {
    if (!isPageVisible(APPLICATION_STEPS.SUBJECT_PROPERTY)) return true;
    await subjectPropertyExistingMortgageValidator$.value.$validate();
    return !subjectPropertyExistingMortgageValidator$.value.$invalid;
  };
  const areApplicantsValid = async () => {
    if (!isPageVisible(APPLICATION_STEPS.APPLICANTS)) return true;
    const result = await applicantsValidator$.value.$validate();
    return result;
  };
  const areIdentificationsValid = async () => {
    if (!isPageVisible(APPLICATION_STEPS.IDENTIFICATIONS)) return true;
    const result = await identificationValidator$.value.$validate();
    return result;
  };
  const areIncomeHistoriesValid = async () => {
    const result = await incomeHistoryValidator$.value.$validate();
    return result;
  };
  const atLeastOneIncomePerApplicant = () => {
    var _context3;
    return _filterInstanceProperty(_context3 = allApplicants.value).call(_context3, applicant => isApplicantVisibleFromFillOut(applicant.id)).every(applicant => {
      var _applicant$employment;
      return (_applicant$employment = applicant.employment) == null ? void 0 : _applicant$employment.length;
    });
  };
  const areAdditionalIncomesValid = async () => {
    const result = await additionalIncomeValidator$.value.$validate();
    return result;
  };
  const areAssetsValid = async () => {
    const result = await assetValidator$.value.$validate();
    return result;
  };
  const areLiabilitiesValid = async () => {
    const result = await liabilityValidator$.value.$validate();
    return result;
  };
  const areOtherPropertiesValid = async () => {
    const result = await otherPropertyValidator$.value.$validate();
    return result;
  };
  const areOtherPropertyExistingMortgageValid = async () => {
    const result = await otherPropertyExistingMortgageValidator$.value.$validate();
    return result;
  };
  const getInvalidApplicants = async () => {
    var _context4, _context5;
    await applicantsValidator$.value.$validate();
    const result = _reduceInstanceProperty(_context4 = _filterInstanceProperty(_context5 = allApplicants.value).call(_context5, areRulesVisibleFromFillOut)).call(_context4, (invalidApplicants, applicant, index) => {
      var _applicantsValidator$, _applicantsValidator$2;
      if ((_applicantsValidator$ = (_applicantsValidator$2 = applicantsValidator$.value[index]) == null ? void 0 : _applicantsValidator$2.$invalid) != null ? _applicantsValidator$ : false) invalidApplicants.push(_objectSpread(_objectSpread({}, applicant), applicantsValidator$.value[index]));
      return invalidApplicants;
    }, []);
    return result;
  };
  const getInvalidIdentifications = async () => {
    var _context6, _context7;
    if (!isPageVisible(APPLICATION_STEPS.IDENTIFICATIONS)) return [];
    await identificationValidator$.value.$validate();
    return _reduceInstanceProperty(_context6 = _filterInstanceProperty(_context7 = allIdentifications.value).call(_context7, areRulesVisibleFromFillOut)).call(_context6, (invalidIdentifications, identification, index) => {
      var _identificationValida, _identificationValida2;
      if ((_identificationValida = (_identificationValida2 = identificationValidator$.value[index]) == null ? void 0 : _identificationValida2.$invalid) != null ? _identificationValida : false) invalidIdentifications.push(identification);
      return invalidIdentifications;
    }, []);
  };
  const getInvalidIncomes = async () => {
    var _context8, _context9;
    await incomeHistoryValidator$.value.$validate();
    return _reduceInstanceProperty(_context8 = _filterInstanceProperty(_context9 = allEmployments.value).call(_context9, areRulesVisibleFromFillOut)).call(_context8, (invalidIncomes, income, index) => {
      var _incomeHistoryValidat, _incomeHistoryValidat2;
      if ((_incomeHistoryValidat = (_incomeHistoryValidat2 = incomeHistoryValidator$.value[index]) == null ? void 0 : _incomeHistoryValidat2.$invalid) != null ? _incomeHistoryValidat : false) invalidIncomes.push(income);
      return invalidIncomes;
    }, []);
  };
  const getInvalidAdditionalIncomes = async () => {
    var _context0, _context1;
    await additionalIncomeValidator$.value.$validate();
    return _reduceInstanceProperty(_context0 = _filterInstanceProperty(_context1 = allAdditionalIncomes.value).call(_context1, areRulesVisibleFromFillOut)).call(_context0, (invalidAdditionalIncomes, income, index) => {
      var _additionalIncomeVali, _additionalIncomeVali2;
      if ((_additionalIncomeVali = (_additionalIncomeVali2 = additionalIncomeValidator$.value[index]) == null ? void 0 : _additionalIncomeVali2.$invalid) != null ? _additionalIncomeVali : false) invalidAdditionalIncomes.push(income);
      return invalidAdditionalIncomes;
    }, []);
  };
  const getInvalidAssets = async () => {
    var _context10, _context11;
    await assetValidator$.value.$validate();
    return _reduceInstanceProperty(_context10 = _filterInstanceProperty(_context11 = allAssets.value).call(_context11, areRulesVisibleFromFillOut)).call(_context10, (invalidAssets, asset, index) => {
      var _assetValidator$$valu, _assetValidator$$valu2;
      if ((_assetValidator$$valu = (_assetValidator$$valu2 = assetValidator$.value[index]) == null ? void 0 : _assetValidator$$valu2.$invalid) != null ? _assetValidator$$valu : false) invalidAssets.push(asset);
      return invalidAssets;
    }, []);
  };
  const getInvalidLiabilities = async () => {
    var _context12, _context13;
    if (!isPageVisible(APPLICATION_STEPS.LIABILITIES)) return [];
    await liabilityValidator$.value.$validate();
    return _reduceInstanceProperty(_context12 = _filterInstanceProperty(_context13 = allLiabilities.value).call(_context13, areRulesVisibleFromFillOut)).call(_context12, (invalidLiabilities, liability, index) => {
      var _liabilityValidator$$, _liabilityValidator$$2;
      if ((_liabilityValidator$$ = (_liabilityValidator$$2 = liabilityValidator$.value[index]) == null ? void 0 : _liabilityValidator$$2.$invalid) != null ? _liabilityValidator$$ : false) invalidLiabilities.push(liability);
      return invalidLiabilities;
    }, []);
  };
  const getInvalidOtherProperties = async () => {
    var _context14, _context15;
    await otherPropertyValidator$.value.$validate();
    return _reduceInstanceProperty(_context14 = _filterInstanceProperty(_context15 = allOtherProperties.value).call(_context15, areRulesVisibleFromFillOut)).call(_context14, (invalidOtherProperties, property, index) => {
      var _otherPropertyValidat, _otherPropertyValidat2;
      if ((_otherPropertyValidat = (_otherPropertyValidat2 = otherPropertyValidator$.value[index]) == null ? void 0 : _otherPropertyValidat2.$invalid) != null ? _otherPropertyValidat : false) invalidOtherProperties.push(property);
      return invalidOtherProperties;
    }, []);
  };
  const getInvalidOtherPropertyExistingMortgages = async () => {
    var _context16, _context17;
    await otherPropertyExistingMortgageValidator$.value.$validate();
    return _reduceInstanceProperty(_context16 = _filterInstanceProperty(_context17 = allOtherPropertiesExistingMortgage.value).call(_context17, areRulesVisibleFromFillOut)).call(_context16, (invalidExistingMortgages, existingMortgage, index) => {
      var _otherPropertyExistin, _otherPropertyExistin2;
      if ((_otherPropertyExistin = (_otherPropertyExistin2 = otherPropertyExistingMortgageValidator$.value[index]) == null ? void 0 : _otherPropertyExistin2.$invalid) != null ? _otherPropertyExistin : false) invalidExistingMortgages.push(existingMortgage);
      return invalidExistingMortgages;
    }, []);
  };
  return {
    stepsValidations: {
      [APPLICATION_STEPS.GOALS]: () => isGoalsPageValid(),
      [APPLICATION_STEPS.SUBJECT_PROPERTY]: async () => (await isSubjectPropertyValid()) && (await areSubjectPropertyExistingMortgagesValid()),
      [APPLICATION_STEPS.APPLICANTS]: () => areApplicantsValid(),
      [APPLICATION_STEPS.IDENTIFICATIONS]: () => areIdentificationsValid(),
      [APPLICATION_STEPS.INCOME_HISTORY]: async () => atLeastOneIncomePerApplicant() && (await areIncomeHistoriesValid()) && (await areAdditionalIncomesValid()),
      [APPLICATION_STEPS.ASSETS]: () => areAssetsValid(),
      [APPLICATION_STEPS.LIABILITIES]: () => areLiabilitiesValid(),
      [APPLICATION_STEPS.OTHER_PROPERTIES]: async () => (await areOtherPropertiesValid()) && areOtherPropertyExistingMortgageValid()
    },
    getInvalidApplicants: async () => await getInvalidApplicants(),
    getInvalidIdentifications: async () => await getInvalidIdentifications(),
    getInvalidIncomes: async () => await getInvalidIncomes(),
    getInvalidAdditionalIncomes: async () => await getInvalidAdditionalIncomes(),
    getInvalidAssets: async () => await getInvalidAssets(),
    getInvalidLiabilities: async () => await getInvalidLiabilities(),
    getInvalidOtherProperties: async () => await getInvalidOtherProperties(),
    getInvalidOtherPropertyExistingMortgages: async () => await getInvalidOtherPropertyExistingMortgages(),
    atLeastOneIncomePerApplicant
  };
};